import { render, staticRenderFns } from "./MedicalRecords.html?vue&type=template&id=ce184c88&external"
import script from "./MedicalRecords.vue?vue&type=script&lang=js"
export * from "./MedicalRecords.vue?vue&type=script&lang=js"
import style0 from "./MedicalRecords.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports